<template>
    <div class="task-release--add-sync">
        <div class="content">
        <vxe-table
            class='atb-table header-table edit-table'
            border='full'
            height='100%'
            auto-resize
            resizable
            :data="yearTableData"
            ref="yearTableData"
            :row-class-name="setRowClass"
            :merge-cells="mergeCells"
        >
            <vxe-table-column type='radio' width='40' align='center'>
              <template #radio="scope">
                  <template v-if="scope.rowIndex === 0">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>重要KPI</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>业务工作</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + 2">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>费效管理</span>
                </div>
              </template>
               <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + 3">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>个人成长</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + pgLength + 4">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>其他新增工作</span>
                </div>
              </template>
                   <template v-else>
                    <span title="选择/取消" :class="['vxe-cell--radio', scope.checked ? 'is--checked' : '']" @click.stop="selected(scope.row)">
                      <span class="vxe-radio--icon vxe-radio--checked-icon"></span>
                      <span class="vxe-radio--icon vxe-radio--unchecked-icon"></span>
                      <span class="vxe-radio--icon vxe-radio--indeterminate-icon"></span>
                    </span>
                  </template>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemCategory" title="类别" width="120"></vxe-table-column>
            <vxe-table-column field="workItemContent" width="120" title="工作项目" :edit-render="{name: 'ElAutocomplete', enabled: disabled, autofocus: '.el-input__inner'}">
            </vxe-table-column>
            <vxe-table-column field="fullTarget" title="总目标">
            </vxe-table-column>
            <vxe-table-column field="startDate" width="120" title="开始时间">
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            <vxe-table-column field="finishDate" width="120" title="最终完成时间">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            </vxe-table>
        </div>
        <div class="form-wrap">
          <el-form :model="editForm" :rules="rules" ref="form" label-width='100px' class="atb-input" label-position="right">
            <el-row>
                <el-col :span="14">    
                    <el-form-item label="指定人" prop="resWkNo" label-width="75px">
                      <selecter v-model="editForm.resWkNo" @selecterData="getSelecterData"></selecter>
                    </el-form-item>
                </el-col>
                <el-col :span="10">    
                    <el-form-item label="权重" prop="weight" label-width="60px">
                      <el-autocomplete v-model="editForm.weight" :fetch-suggestions="querySearchWeight" placeholder="权重" @input="handleInputChange" clearable></el-autocomplete>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="btn-wrap">
            <el-button type="save" class="btn" @click="save">保存</el-button>
            <el-button type="saveAndRelease" class="btn" @click="saveAndRelease">发布</el-button>
            <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import XEUtils from 'xe-utils'
export default {
  components: {
    selecter:()=>import('@/component/global/customerSelect')
  },
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      id: 'id',
      editForm: {},
      summaryData:{},
      weightList:[],
      mergeCells: [
        {row: 0, col: 0, rowspan: 1, colspan: 6},
        {row: 1, col: 0, rowspan: 1, colspan: 6},
        {row: 2, col: 0, rowspan: 1, colspan: 6},
        {row: 3, col: 0, rowspan: 1, colspan: 6},
        {row: 4, col: 0, rowspan: 1, colspan: 6}
      ],
      kpi: [],
      normal: [],
      create: [],
      hr:[],
      cc:[],
      pg:[],
      other: [],
      selectedData:{},
      rules: {
        weight: [
          { required: true, message: '请选择权重', trigger: 'change' }
        ],
        resWkNo: [
          { required: true, message: '请选择指定人', trigger: 'change' },
        ]
      },
      assignData:[],
    }
  },
  computed: {
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      normalLength() {
        return this.normal.length;
      },
      createLength() {
        return this.create.length;
      },
      //个人成长
      pgLength() {
        return this.pg.length;
      },
      otherLength() {
        return this.other.length;
      },
      yearTableData() {
        return [{}, ...this.kpi, {}, ...this.normal, {}, ...this.create, {},...this.pg, {}, ...this.other];
      }
    },
  mounted(){
    this.getYearWorkList();
    this.getWeightDict();
  },
  methods:{
    querySearchWeight(queryString, cb) {
        let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
    },
    getYearWorkList() {
      this.$ajax.get(this.$api.year.yearWorkDetail.list,{year: 1}).then((res) => {
        res.data&&this.filterSyncTableData(res.data.details);
        if (!res.data) {
          this.yearTableData = [{}, {}, {}, {}, {}];
        }
      });
    },
    filterSyncTableData(data) {
        if(XEUtils.isArray(data)){
          this.kpi = data.filter(val => val.workClassify == 0);
          this.normal = data.filter(val => val.workClassify == 10);
          this.create = data.filter(val => val.workClassify == 20);
          this.pg = data.filter(val => val.workClassify == 50);
          this.other = data.filter(val => val.workClassify == 60);
        }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    setRowClass({rowIndex}) {
      if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.normalLength + 2 || rowIndex == this.kpiLength + this.normalLength + this.createLength + 3 || rowIndex == this.kpiLength + this.normalLength + this.createLength + this.pgLength + 4) {
        return 'main-row';
      }
    },
    selected(row) {
      this.$refs.yearTableData.setRadioRow(row);
      this.selectedData=row;
    },
    save() {
      //通过后提交数据
      const record = this.$refs.yearTableData.getRadioRecord();
      if(!record){
        return this.$message.error('请勾选表格内的工作项');
      }
      if(record){
        if (!record.workItemContent || !record.fullTarget || !record.startDate || !record.finishDate){
          return this.$message.error('计划内容填写不完整，工作项目、总目标、开始时间、最终完成时间均不能为空');
        }
        this.$refs["form"].validate(valid=>{
        //通过后提交数据
        if(valid){
          const params={};
          const resWkObj=this.assignData.find(t=>t.jobNo===this.editForm.resWkNo);
          params.workItemCategory=record.workItemCategory;
          params.workItemContent=record.workItemContent;
          params.workClassify=record.workClassify;
          params.fullTarget=record.fullTarget;
          params.finishFullTarget=record.fullTarget;
          params.startDate=record.startDate;
          params.finishDate=record.finishDate;
          params.weight=this.editForm.weight;
          params.resWkName=resWkObj? resWkObj.name: '';
          params.resWkNo=this.editForm.resWkNo;
          params.source= 3;
          params.sourceId=record.id;
          this.$ajax.post(this.$api.add.PublishYearWork.adu, params).then(res=>{
            if(res.code===0){
                this.$refs.form.resetFields();
                this.$message.success('保存成功');
                this.$emit('submitSuccess');
                this.editForm={};
                if(!this.checked)
                this.$parent.$parent.hide();
            }
          });
         }
        });
      }
    },
    saveAndRelease(){
        const record = this.$refs.yearTableData.getRadioRecord();
        if (!record){
          return this.$message.error('请勾选表格内的工作项');
        }
        if (record){
          if (!record.workItemContent || !record.fullTarget || !record.startDate || !record.finishDate){
            return this.$message.error('计划内容填写不完整，工作项目、总目标、开始时间、最终完成时间均不能为空');
          }
          this.$refs["form"].validate(valid=>{
          //通过后提交数据
          if(valid){
            const params={};
            const resWkObj=this.assignData.find(t=>t.jobNo===this.editForm.resWkNo);
            params.workItemCategory=record.workItemCategory;
            params.workItemContent=record.workItemContent;
            params.workClassify=record.workClassify;
            params.fullTarget=record.fullTarget;
            params.finishFullTarget=record.fullTarget;
            params.startDate=record.startDate;
            params.finishDate=record.finishDate;
            params.weight=this.editForm.weight;
            params.resWkName=resWkObj? resWkObj.name:'';
            params.resWkNo=this.editForm.resWkNo;
            params.source= 3;
            params.sourceId=record.id;
            this.$ajax.put(this.$api.add.PublishYearWork.saveAndRelease, params).then(res=>{
              if(res.code===0){
                  this.$refs.form.resetFields();
                  this.$message.success('发布成功');
                  this.$emit('submitSuccess');
                  this.editForm={};
                  if(!this.checked)
                  this.$parent.$parent.hide();
              }
            });
          }
        });
      }
    },
    getSelecterData(data){
        this.assignData=data;
    },
    getWeightDict(){
        this.$ajax.get(this.$api.common.getDict,{ItemType:'WorkWeight'}).then((res)=>{
            if(res.code===0){
                this.weightList=[];
                res.data.rows.forEach(t=>{
                  this.weightList.push({value:eval(t.itemValue)});
                });
            }
        });
    },
    handleInputChange(value) {
      value = value + '';
      value = value.trim();
      // 只能输入数字
      value = value.replace(/[^\d]/g, '')
      if (value) {
        value = parseInt(value);
        if (value < 1) value = 1;
        if (value > 100) value = 100;
      }
      this.editForm.weight = value;
    },
  },
 watch: {
      yearTableData: {
        handler() {
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: 6},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: 6},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: 6},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: 6},
            {row: this.kpiLength + this.normalLength + this.createLength + this.pgLength + 4, col: 0, rowspan: 1, colspan: 6},
          ];
        }
      }
    }
}
</script>
<style scoped lang='scss'>
  .task-release--add-sync {
    .content{
        height: 450px;
    }
    .el-button.el-button--save {
        color: #ffffff;
        background-color: #22b6a1;
        border-color: #22b6a1;
    }
    .el-button.el-button--saveAndRelease {
        background-color: #0dcc82;
        border-color: #0dcc82;
        color: #ffffff;
    }
    .el-button.el-button--clear {
        background-color: #F5BF2B;
        border-color: #F5BF2B;
        color: #ffffff;
    }
    .el-button {
        width: 110px;
        border-radius: 10px;
    }
    .btn-wrap{
         text-align: right;
         margin-top: 10px;
    }
    .form-wrap{
        margin: 10px 0px;
        .el-autocomplete{
            width: 100%;
        }
        .customerSelect{
            width: 100%;
        }
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-body--column {
          padding: 0;
        }
        .vxe-cell {
          padding: 0;
        }
      }
    }
    .kpi-add {
      height: 48px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      margin-top: -1px;
      padding: 0 15px;
      span {
        cursor: pointer;
      }
    }
  }
</style>